/**
 * Need to delay the init of these event listeners by 1 second for the main JS to load and
 * the plugin used to process the events
 * @param {Object} state The call-tos store state
 */
export function dropdownFilterElms(state) {
    setTimeout(() => {
        const a11ySelectItems = document.querySelectorAll(
            '.custom-a11yselect-option'
        );
        if (a11ySelectItems.length) {
            [...a11ySelectItems].map(elm =>
                elm
                    .querySelector('button')
                    .addEventListener('click', () => getDropdownValue(elm, state))
            );
        }
    }, 1000);
}

/**
 * Grabs the values for the elm
 * @param {HTMLElement} elm The HTML Element
 * @param {Object} state The elements store state
 */
export function getDropdownValue (elm, state) {
    const value = elm.dataset.val || '';
    const key = elm.closest('[data-source]').dataset.source;
    state[key] = value;
    state.query[key] = value;

    state.apiParams && (state.apiParams[key] = value);
}

/**
 * Resets the store state
 *
 * @param {Object} store The Pinia store state
 */
export function resetState (store) {
    store.$reset()
}

/**
 * Hooks to the dataLayer from GA to attach an event from
 * an on-page action
 *
 * @param {Object} data
 */
export const dataLayer = (data = {}) => {
    const { dataLayer } = window;
    if (dataLayer) dataLayer.push(data);
}

/**
 * Sets up the Reify Prescreener if using the Flexible Template Prescreener
 * @param {Object} state  Object data passed
 * @param {Object} siteId The data passed from the handler
 */
export function reifyPrescreener(state, siteId) {
    const {StudyTeamForm} = window;
    const {locale, micrositeId, queryParams, sessionId, trialId} = state;
    const reifyContainerElm = document.getElementById('reify-container');
    const formData = {
        sponsorSiteId: `${siteId}`,
        micrositeId,
        trialId,
        tracking: queryParams || {},
        locale,
        initialValues: {},
    }

    if (sessionId) {
        formData.sessionId = sessionId;
    }

    if (StudyTeamForm && reifyContainerElm) {
        StudyTeamForm.display({
            container: reifyContainerElm,
            ...formData,
            iframeProps: {
                style: {
                    overflow: 'auto'
                }
            },
        })
    }
}


/**
 * Resets the labels on the search filter options
 */
export const resetSearchFilters = () => {
    const selectItems = document.querySelectorAll('.select-item');
    [...selectItems].map(elm => {
        const selectLabel = elm.querySelector('.custom-a11yselect-text')
        const firstItem = [...elm.querySelectorAll('.custom-a11yselect-option')][0]
        selectLabel.innerText = firstItem.querySelector('button')?.innerText || ''
    })
}

/**
 * Converts a snake_case string to camelCase
 * @param {String} value The snake_case string to convert
 * @returns {*}
 */
export const snakeCaseConvert = (value) => value.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
